import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const LegalPageLayout = ({ title, intro, children }) => {
  return (
    <div className="min-h-screen bg-[#030303]">
      <Navbar />

      <main className="relative overflow-hidden pt-40 pb-16 md:pt-48 md:pb-24 px-6 md:px-8">
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-[-12rem] mx-auto h-[30rem] w-[30rem] rounded-full bg-white/[0.04] blur-[120px] pointer-events-none"
        />

        <section className="relative max-w-5xl mx-auto">
          <div className="max-w-3xl">
            <span className="inline-flex items-center rounded-full border border-white/[0.12] bg-white/[0.02] px-3 py-1 text-[10px] font-['Manrope'] uppercase tracking-[0.2em] text-neutral-400">
              Mayr Technologies
            </span>
            <h1 className="mt-6 font-['Outfit'] text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[0.95]">
              {title}
            </h1>
            <p className="mt-6 max-w-2xl font-['Manrope'] text-base md:text-lg leading-relaxed text-neutral-400">
              {intro}
            </p>
          </div>

          <div className="section-divider mt-12 mb-8" />

          <div className="space-y-4">
            {children}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPageLayout;
